module.exports = __webpack_public_path__ + "img/za.f636c4cd.png";